import * as Sentry from "@sentry/react";

function Fallback({ error, resetError }) {
  return (
    <main
      role="alert"
      data-testid="sentry-error-boundary"
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#F5F2EB",
        color: "#0A1128",
        padding: "48px 24px",
        fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 520,
          background: "#fff",
          border: "1px solid #E5E0D5",
          padding: 32,
          borderRadius: 2,
        }}
      >
        <p style={{ letterSpacing: "0.16em", fontSize: 11, textTransform: "uppercase", color: "#888" }}>
          TrendRise AI
        </p>
        <h1 style={{ fontFamily: "Georgia, serif", fontSize: 28, margin: "8px 0 12px" }}>
          Something went wrong on this page
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.6, color: "#333" }}>
          The problem has been reported to our monitoring. Try refreshing, or head back to the dashboard.
        </p>
        <div style={{ marginTop: 24, display: "flex", gap: 8 }}>
          <button
            data-testid="sentry-fallback-retry"
            onClick={resetError}
            style={{
              background: "#C5A059",
              color: "#0A1128",
              border: "none",
              padding: "10px 18px",
              borderRadius: 2,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Retry
          </button>
          <a
            href="/"
            data-testid="sentry-fallback-home"
            style={{
              padding: "10px 18px",
              border: "1px solid #E5E0D5",
              borderRadius: 2,
              color: "#0A1128",
              textDecoration: "none",
            }}
          >
            Home
          </a>
        </div>
        {process.env.NODE_ENV !== "production" && error ? (
          <pre style={{ marginTop: 16, fontSize: 11, color: "#8a2f2f", whiteSpace: "pre-wrap" }}>
            {String(error?.message || error)}
          </pre>
        ) : null}
      </div>
    </main>
  );
}

export function AppErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => <Fallback error={error} resetError={resetError} />}
      beforeCapture={(scope) => scope.setTag("component", "react-root")}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default AppErrorBoundary;
